import { ProfitProps } from './props';
import { WalletService } from '@starsoft/common/services';
import styles from './styles.module.scss';
import defaultStyles from '../styles.module.scss';
import { RoundStatus } from '@/models/round/status';
import { Nullable } from '@starsoft/common/interfaces';
import { Bet } from '@/models/bet';
import { MoneyService as Money } from '@starsoft/common/services';
import { useMemo } from 'react';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import { GameRoundStatusId } from '@/models/round/status/id';

export default function Profit({
  isLoading,
  round,
  shouldShowResult,
}: ProfitProps) {
  if (isLoading) {
    return <div className={styles['text-skeleton']} />;
  }

  return (
    <span className={defaultStyles.container__label}>
      {WalletService.maskCurrency({
        amount:
          round?.analytics?.payout?.convertedAmounts?.['usdt']?.toNumber(),
      })}
    </span>
  );
}
